import { type MCPServerInfo } from '../../types';

const GoogleChatServer: MCPServerInfo = {
  serverId: 'GOOGLE_CHAT',
  name: 'Google Chat',
  slug: 'google-chat',
  description:
    'Official Google-hosted Chat MCP Server for searching conversations and listing messages',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://chatmcp.googleapis.com/mcp/v1',
    transport: 'STREAMABLE_HTTP'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  },
  annotations: {
    hintPreRegistered: true
  }
};

export default GoogleChatServer;
